"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMasterUserFinalClaim = exports.masterUserFinalClaimSchema = void 0;
var constants_1 = require("@hobt/constants");
var schema_validator_1 = require("@hobt/schema-validator");
var adjudication_calculation_1 = require("./adjudication-calculation");
var applicable_rate_1 = require("./applicable-rate");
var approval_1 = require("./approval");
var assessment_1 = require("./assessment");
var borrower_1 = require("./borrower");
var borrower_charge_1 = require("./borrower-charge");
var calculation_detail_1 = require("./calculation-detail");
var cash_receipt_1 = require("./cash-receipt");
var constants_2 = require("../constants");
var default_management_1 = require("./default-management");
var detail_1 = require("./detail");
var document_access_control_entry_schema_1 = require("../common/document-access-control-entry-schema");
var financial_transaction_1 = require("./financial-transaction");
var indicator_1 = require("./indicator");
var lender_1 = require("./lender");
var listing_1 = require("./listing");
var loan_administration_1 = require("./loan-administration");
var loan_detail_1 = require("./loan-detail");
var mandatory_documentation_1 = require("./mandatory-documentation");
var other_adjustment_1 = require("./other-adjustment");
var pending_condition_1 = require("./pending-condition");
var pre_adjudication_verification_1 = require("./pre-adjudication-verification");
var profile_1 = require("./profile");
var property_1 = require("./property");
var response_1 = require("./response");
var remark_1 = require("./remark");
var suspense_condition_1 = require("./suspense-condition");
var validation_result_1 = require("./validation-result");
exports.masterUserFinalClaimSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'approvedLenderFinancialInstitutionCode',
        'approvedLenderReferenceNumber',
        'approvedLenderTransitNumber',
        'cmhcLoanAccountNumber',
        'claimTypeIndicator',
        'documentAccessControlEntry',
        'exceptionToListingFlag',
        'newInternalAttachmentFlag',
        'newInternalCommentFlag',
        'newExternalAttachmentFlag',
        'newExternalCommentFlag',
        'partialPaymentReceivedFlag',
        'recordCreatedTimestamp',
        'recordCreatedUserID',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'rentalIncomeReceivedFlag',
        'sequenceNumber',
    ],
    properties: {
        approvedLenderFinancialInstitutionCode: {
            type: 'string',
            minLength: 3,
            maxLength: 3,
            errorMessage: 'Should be a string with a length of 3 characters',
        },
        approvedLenderReferenceNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters',
        },
        approvedLenderTransitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with a length of 5 characters',
        },
        claimBusinessID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        claimID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        claimTypeIndicator: {
            type: 'number',
            enum: Object.values(constants_2.ClaimTypeIndicator),
            errorMessage: 'Should equate to a valid ClaimTypeIndicator Enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'number',
            minimum: 10000000,
            maximum: 99999999,
            errorMessage: 'Should be a numeric value with 8 digits',
        },
        exceptionToListingFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        newInternalAttachmentFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        newInternalCommentFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        newExternalAttachmentFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        newExternalCommentFlag: {
            type: 'boolean',
            errorMessage: 'Should be boolean',
        },
        partialPaymentReceivedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        recordCreatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        rentalIncomeReceivedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'Should be boolean',
        },
        sequenceNumber: {
            type: 'number',
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be an integer between 0 and 2147483647',
        },
        adjudicationCalculation: adjudication_calculation_1.adjudicationCalculationSchema,
        applicableRate: applicable_rate_1.applicableRateSchema,
        approval: approval_1.approvalSchema,
        assessment: assessment_1.assessmentSchema,
        borrowers: {
            type: ['array', 'null'],
            items: borrower_1.borrowerSchema,
        },
        borrowerCharges: {
            type: ['array', 'null'],
            items: borrower_charge_1.borrowerChargeSchema,
        },
        calculationDetail: calculation_detail_1.calculationDetailSchema,
        cashReceipts: {
            type: ['array', 'null'],
            items: cash_receipt_1.cashReceiptSchema,
        },
        defaultManagement: default_management_1.defaultManagementFinalClaimSchema,
        detail: detail_1.detailFinalClaimSchema,
        documentAccessControlEntry: document_access_control_entry_schema_1.documentAccessControlEntrySchema,
        financialTransaction: financial_transaction_1.financialTransactionSchema,
        indicator: indicator_1.indicatorFinalClaimSchema,
        lender: lender_1.finalLenderSchema,
        listings: {
            type: 'array',
            items: listing_1.finalListingSchema,
            minItems: 1,
        },
        loanAdministration: loan_administration_1.loanAdministrationSchema,
        loanDetail: loan_detail_1.loanDetailSchema,
        mandatoryDocumentation: mandatory_documentation_1.mandatoryDocumentationSchema,
        otherAdjustments: {
            type: ['array', 'null'],
            items: other_adjustment_1.otherAdjustmentSchema,
            hasValidOtherAdjustmentCounts: true,
        },
        preAdjudicationVerification: pre_adjudication_verification_1.preAdjudicationVerificationSchema,
        pendingConditions: {
            type: ['array', 'null'],
            items: pending_condition_1.pendingConditionSchema,
        },
        profile: profile_1.profileSchema,
        property: property_1.finalPropertySchema,
        remark: remark_1.remarkSchema,
        response: response_1.responseSchema,
        suspenseConditions: {
            type: ['array', 'null'],
            items: suspense_condition_1.suspenseConditionSchema,
        },
        validationResult: validation_result_1.validationResultFinalClaimSchema,
    },
};
exports.validateMasterUserFinalClaim = function (data) {
    var masterUserFinalClaimValidator = new schema_validator_1.SchemaValidator(exports.masterUserFinalClaimSchema, true, false, true, true);
    return masterUserFinalClaimValidator.validate(data);
};
